import { LogFirebase } from "../../../../../services/firestore";
import { handleVideoTrackUnsubscribed } from "./handleVideoTrackUnsubscribed";

export const trackUnsubscribedEvent = (track, remoteTrackPrublication, participant) => {
    if (track) {
        LogFirebase("TwilioEvents", "trackUnsubscribedFromRoom", {
            track_details: track.kind,
            participant_details: participant.identity,
        });

        if (track.kind == "video") {
            handleVideoTrackUnsubscribed(track, remoteTrackPrublication, participant);
        }
    }
};
